import { Component, input, output } from '@angular/core';
import { DkCurrencyPipe } from 'src/app/shared/pipes/dk-currency';
import { PriceRegulation, PriceRegulationType } from 'src/app/features/prices/price-regulations/price-regulation';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { TranslatePriceRegulationTypePipe } from 'src/app/shared/pipes/translate-price-regulation-type.pipe';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'adm-step4-price-regulations-list',
  templateUrl: './price-regulations-list.component.html',
  styleUrl: './price-regulations-list.component.scss',
  imports: [DkCurrencyPipe, MatButtonModule, MatTableModule, TranslatePriceRegulationTypePipe, MatTooltip],
})
export class Step4PriceRegulationsListComponent {
  regulations = input<PriceRegulation[]>([]);
  editRegulation = output<PriceRegulation>();
  deleteRegulation = output<PriceRegulation>();
  displayColumns: string[] = ['name', 'type', 'regulation', 'actions'];

  protected readonly PriceRegulationType = PriceRegulationType;
}
